
import { Avatar } from '@/components/ui/avatar';
import { User } from '@/types/user';

interface UserAvatarProps {
  user: User;
}

export function UserAvatar({ user }: UserAvatarProps) {
  return (
    <div className="flex items-center gap-3">
      <Avatar>
        <div className="flex h-full w-full items-center justify-center bg-muted text-xs font-medium uppercase text-muted-foreground">
          {user.name.substring(0, 2)}
        </div>
      </Avatar>
      <div className="flex flex-col">
        <span className="font-medium">{user.name}</span>
        <span className="text-xs text-muted-foreground">{user.email}</span>
      </div>
    </div>
  );
}
